﻿'use strict';

angular.module('ntmApp').factory('CensusProjection', ['ForecastService', 'FlashService', 'CensusProjectionFilter', 'Utils', '$q', 'ForecastingFiltersProvider',
function (ForecastService, FlashService, CensusProjectionFilter, Utils, $q, ForecastingFiltersProvider) {

    function CensusProjection() {

        var self = this;
        self.filter = new CensusProjectionFilter();

        self.filterSettings = {
            displayProp: 'value',
            attachDisplayProp: true,
            smartButtonMaxItems: 10,
            scrollableHeight: '200px',
            enableSearch: true
        };

        self.toggleFilter = function () {
            self.showFilter = !self.showFilter;
        };

        self.multiSelectEvents = {
            onItemSelect: function () {
                self.applyFilter();
            },
            onItemDeselect: function () {
                self.applyFilter();
            },
            onDeselectAll: function () {
                self.applyFilter();
            }
        };

        self.clearFilter = function (filter) {
            filter.clear();
            self.applyFilter();
        };

        self.clearAllFilters = function () {
            self.filter.clearAllFilters();
            self.applyFilter();
        };

        self.applyFilter = function () {
            self.filteredCensusProjections = self.filter.filterItems(self.censusProjections);
        };

        self.load = function (header, selectedWeek, scenarioId, forecastMode) {

            var data = {
                dateFrom: selectedWeek.startDate,
                dateTo: selectedWeek.endDate,
                forecastMode: forecastMode,
                forecastView: header.forecastOptionsSummary.forecastView,
                forecastScope: header.selectedForecastScope.id,
                scenarioBreadcrumb: scenarioId
            };

            self.loading = true;
            ForecastService.GetCensusProjections(data).then(function (result) {

                if (result.success) {
                    self.censusProjections = result.data.censusProjections;
                    self.roomItems = getRoomItems(self.censusProjections); 

                    if (self.censusProjections) {
                        self.censusProjections.forEach(function (censusProjection) {

                            if (censusProjection.roomAssignees) {
                                censusProjection.roomAssigneesList = censusProjection.roomAssignees.join("; ");
                            }

                            censusProjection.daysRange = generateDaysRangeForGroupBlock(censusProjection);
                        });
                    }

                    groupCensusProjectionsByDays(self.censusProjections);
                    self.originalCensusProjections = angular.copy(self.censusProjections);
                    self.filteredCensusProjections = self.censusProjections;

                    ForecastingFiltersProvider.LoadFilters().then(function (filters) {
                        self.filterDataSource = {
                            roomTypes: filters.roomTypeFilters,
                            species: filters.speciesFilters,
                            rackTypes: filters.rackTypeFilters
                        };

                        Utils.AddBlankOption(self.filterDataSource.roomTypes);
                        Utils.AddBlankOption(self.filterDataSource.species);
                        Utils.AddBlankOption(self.filterDataSource.rackTypes);

                        self.applyFilter();
                        self.loading = false;
                    });
                }
            });
        };

        function getRoomItems(censusProjections) {

            if (censusProjections) {
                return censusProjections.map(function (censusBlock) {
                    return {
                        id: censusBlock.roomNumber.trim(),
                        value: censusBlock.roomNumber.trim()
                    };
                }).unique(function (item1, item2) {
                    return item1.id === item2.id;
                });
            }

            return [];
        }

        self.calculateDiscrepancyScore = function (censusProjection) {

            var discrepancyScore = 0;

            censusProjection.totalByDate.forEach(function (total) {

                if (total && total.item) {
                    discrepancyScore += Math.abs(total.item.totalProjectedChanges || 0 -  total.item.totalChanges || 0);
                }
            });

            return discrepancyScore;
        };

        function groupCensusProjectionsByDays(censusProjections) {

            if (censusProjections) {
                censusProjections.forEach(function (censusProjection) {
                    censusProjection.totalByDate = [];

                    censusProjection.daysRange.forEach(function (dow) {
                        censusProjection.blocks.forEach(function (block) {
                            block.itemsGroupedByDate = block.itemsGroupedByDate || [];
                            block.itemsGroupedByDate.push(
                                {
                                    item: block.items.firstOrDefault(function (item) {
                                        return dow.date.diff(moment(item.date), 'days') === 0;
                                    }),
                                    date: dow.date
                                });
                        });

                        censusProjection.totalByDate.push(
                            {
                                item: censusProjection.totalItems.firstOrDefault(function (item) {
                                    return dow.date.diff(moment(item.date), 'days') === 0;
                                }) || {},
                                date: dow.date
                            });
                    });
                });
            }
        }

        function generateDaysRangeForGroupBlock(censusProjection) {

            var daysRange = [];

            if (censusProjection.blocks) {
                censusProjection.blocks.forEach(function (block) {
                    
                    if (block.items) {
                        block.items.forEach(function (item) {
                            if (!daysRange.some(function (dow) {
                                    return dow.date.diff(moment(item.date), 'days') === 0;
                            })) {

                                var current = moment(item.date);
                                var dayLabel = current.format('dddd').substring(0, 3);
                                var month = current.format('M');
                                var day = current.format('D');

                                daysRange.push({
                                    date: current,
                                    label: '{0}:{1}/{2}'.format(dayLabel, month, day)
                                });
                            }
                        });
                    }
                });
            }

            return daysRange;
        }

        self.onCageCountChanged = function (censusProjection, block, grouppedItem) {

            if (!grouppedItem.item.cageCount) {
                grouppedItem.item.cageCount = 0;
            }

            self.changeCageCount(censusProjection, block, grouppedItem);
        };

        function automaticallyUpdateCageCountOfFutureDates(censusProjection, block, grouppedItem) {

            var futureGrouppedItems = block.itemsGroupedByDate.filter(function (item) {
                return item.date.isAfter(grouppedItem.date);
            });

            if (futureGrouppedItems) {
                futureGrouppedItems.forEach(function (futureGrouppedItem) {
                    futureGrouppedItem.item.cageCount = grouppedItem.item.cageCount;
                    futureGrouppedItem.item.isChanged = isCageCountChanged(censusProjection, block, futureGrouppedItem);
                });
            }
        }

        self.changeCageCount = function (censusProjection, block, grouppedItem) {

            automaticallyUpdateCageCountOfFutureDates(censusProjection, block, grouppedItem);
            grouppedItem.item.isChanged = isCageCountChanged(censusProjection, block, grouppedItem); 

            censusProjection.blocks.forEach(function (blockItem) {
                blockItem.isChanged = blockItem.itemsGroupedByDate.some(function (groupped) {
                    return groupped.item && groupped.item.isChanged;
                });
            });

            censusProjection.isChanged = censusProjection.blocks.some(function (blockItem) {
                return blockItem.isChanged;
            });
        };

        self.save = function (censusProjection, scenarioId, selectedWeek) {

            var data = {
                scenarioId: scenarioId,
                censusGroup: censusProjection,
                dateFrom: selectedWeek.startDate,
                dateTo: selectedWeek.endDate,
                facilityCode: censusProjection.facilityCode,
                roomNumber: censusProjection.roomNumber.trim()
            };

            var loading = FlashService.Loading();
            ForecastService.SaveCensusProjections(data).then(function (result) {

                if (result.success) {

                    censusProjection.blocks = result.data.censusGroup.blocks;
                    mergeUpdatedTotalItemsProperties(censusProjection.totalItems, result.data.censusGroup.totalItems);
                    self.calculateDiscrepancyScore(censusProjection);
                    groupCensusProjectionsByDays([censusProjection]);

                    var originalCensusProjection = self.originalCensusProjections.firstOrDefault(function (censusProjectionItem) {
                        return censusProjectionItem.blockName === censusProjection.blockName;
                    });

                    if (originalCensusProjection) {
                        copyCensusProjectionData(censusProjection, originalCensusProjection);
                        setPristine(censusProjection);
                    }

                    if (self.form && self.form.$dirty) {
                        self.form.$setPristine();
                    }

                    FlashService.Success("Data was saved successfully.");
                }

                loading.dismiss();
            });
        };

        function mergeUpdatedTotalItemsProperties(destinationItems, sourceItems) {

            sourceItems.forEach(function (item) {

                var toUpdate = destinationItems.firstOrDefault(function (destinationItem) {
                    var itemDate = moment(item.date);
                    var destinationItemDate = moment(destinationItem.date);
                    return itemDate.isSame(destinationItemDate);
                });

                if (toUpdate) {
                    toUpdate.totalCageCount = item.totalCageCount;
                    toUpdate.totalChanges = item.totalChanges;
                }
            });
        }

        self.getCensusProjectionAndSave = function (scenarioId, selectedWeek) {

            var deferred = $q.defer();

            self.censusProjections.forEach(function (censusProjection) {
                if (censusProjection.isChanged) {
                    self.save(censusProjection, scenarioId, selectedWeek);
                }
            });

            deferred.resolve();
            return deferred.promise;
        };

        self.cancelChanges = function (censusProjection) {

            var originalCensusProjection = self.originalCensusProjections.firstOrDefault(function (censusProjectionItem) {
                return censusProjectionItem.blockName === censusProjection.blockName;
            });

            if (originalCensusProjection) {
                copyCensusProjectionData(originalCensusProjection, censusProjection);
                setPristine(censusProjection);
            }

            if (self.form && self.form.$dirty) {
                self.form.$setPristine();
            }
        };

        self.expandAll = function () {
            self.censusProjections.forEach(function (censusProjection) {
                censusProjection.expanded = true;
            });
        };

        self.callapseAll = function () {
            self.censusProjections.forEach(function (censusProjection) {
                censusProjection.expanded = false;
                self.cancelChanges(censusProjection);
            });
        };

        self.toggleCensusBlock = function (censusProjection) {

            if (!censusProjection.isChanged) {
                censusProjection.expanded = !censusProjection.expanded;
            }
        };

        function isCageCountChanged(censusProjection, block, grouppedItem) {

            var originalBlock = findOriginalBlock(censusProjection, block);

            if (originalBlock) {
                var originalItem = originalBlock.itemsGroupedByDate.firstOrDefault(function (item) {
                    return item.date.diff(grouppedItem.date, 'days') === 0;
                });

                if (originalItem) {
                    return parseInt(originalItem.item.cageCount) !== parseInt(grouppedItem.item.cageCount);
                }
            }

            return false;
        }

        function findOriginalBlock(censusProjection, block) {
            var originalCensusProjection = self.originalCensusProjections.firstOrDefault(function (censusProjectionItem) {
                return censusProjectionItem.blockName === censusProjection.blockName;
            });

            if (originalCensusProjection) {
                return originalCensusProjection.blocks.firstOrDefault(function (blockItem) {
                    return blockItem.groupName === block.groupName;
                });
            }

            return null;
        }

        function setPristine(censusProjection) {
            censusProjection.isChanged = false;
            censusProjection.blocks.forEach(function (block) {
                block.itemsGroupedByDate.forEach(function (grouppedItem) {
                    if (grouppedItem.item) {
                        grouppedItem.item.isChanged = false;
                    }
                });
            });
        }

        function copyCensusProjectionData(source, destination) {
            destination.blocks = angular.copy(source.blocks);
            destination.currentInventoryCount = angular.copy(source.currentInventoryCount);
            destination.totalItems = angular.copy(source.totalItems);
        }
    }

    return (CensusProjection);
}]);